const config = {
  googleAnalytic: "UA-148159211-1"
};

export default config;
